import React from 'react';
/** @jsxRuntime classic */

/** @jsx jsx */

import { jsx } from '@emotion/core';
import classNames from 'classnames';
import { useHistory } from 'react-router-dom';
import { useTheme } from 'emotion-theming';
import styles from './TabBar.style';
const TabBarContext = /*#__PURE__*/React.createContext();

const reducer = (state, action) => {
  switch (action.type) {
    case 'filterItem':
      return state.items.filter(({
        id
      }) => id === action.id);

    case 'setItems':
      {
        const items = [...action.items];

        if (action.item) {
          items.push({ ...action.item,
            childs: [...action.items]
          });
        }

        return { ...state,
          items,
          item: action.item
        };
      }

    case 'updateItems':
      {
        let items = [...state.items];

        if (action.item) {
          const index = items.findIndex(({
            id
          }) => id === action.item.id);

          if (index > -1) {
            items[index].childs = [...action.items];
          }
        }

        const ids = items.map(({
          id
        }) => id);
        const newItems = action.items.filter(({
          id
        }) => !ids.includes(id));
        items = [...items, ...newItems];
        items.sort((a, b) => a.order - b.order);
        return { ...state,
          items,
          item: action.item
        };
      }

    case 'setItem':
      {
        return { ...state,
          item: action.item
        };
      }

    case 'navigate':
      return { ...state,
        currentOption: action.option,
        currentSubItem: '',
        history: []
      };

    case 'navigate-sub-item':
      return { ...state,
        history: [...state.history, action.subItem],
        currentSubItem: action.subItem
      };

    case 'navigate-back':
      {
        const {
          history
        } = state;
        history.pop();
        const current = history.length ? history[history.length - 1] : '';
        return { ...state,
          history,
          currentSubItem: current
        };
      }

    default:
      throw new Error('Unexpected action type');
  }
};

export function useTabBar() {
  const context = React.useContext(TabBarContext);

  if (context === undefined) {
    throw new Error('useTabBar debe se usado dentro de TabBarProvider');
  }

  return context;
}
/**
 * This component is a Item of the tabBar.
 * @param {*} children Li tag content for the item.
 * @param {string} id Li tag id.
 * @param {string} path Path to navigate when click the item
 */

export function Item({
  children,
  id,
  path = ''
}) {
  const [{
    currentOption
  }, dispatch] = useTabBar();
  const history = useHistory();
  return jsx("li", {
    className: classNames('option liTab', {
      active: currentOption === id
    }),
    onClick: () => {
      if (path) {
        history.push(path);
      }

      dispatch({
        type: 'navigate',
        option: id
      });
    }
  }, children);
}
/**
 * This component represents the options of the tabBar.
 * @param {*} children UL tag content for the tabBar.
 */

export function Options({
  children
}) {
  return jsx("ul", {
    className: "options"
  }, children);
}
/**
 * This component represents a container for the tabBar.
 * @param {*} children Contains the tabBar.
 * @param {JSON} style Custom style for the container.
 */

export function Container({
  children,
  style
}) {
  return jsx("div", {
    className: "containerTab",
    style: style
  }, children);
}
/**
 * This component represents a container for procedure options.
 * @param {*} children What will be shown inside the display.
 */

export function Display({
  children
}) {
  return jsx("div", {
    className: "display"
  }, children);
}
/**
 * This component represents a item wrapped in the display component.
 * @param {*} children What will be shown inside the display.
 * @param {string} id Id.
 */

export function DisplayItem({
  children,
  id
}) {
  const [{
    currentOption,
    currentSubItem
  }] = useTabBar();

  if (currentOption && currentSubItem === '' && currentOption === id) {
    return jsx("div", {
      className: classNames('display-item')
    }, children);
  }

  if (currentSubItem === id) {
    return jsx("div", {
      className: classNames('display-item')
    }, children);
  }

  return jsx("div", {
    className: classNames('display-item')
  });
}
/**
 * This component represents the tabBar provider.
 * @param {*} children What will be shown inside the provider.
 * @param {*} initialOption Initial option for the tabBar.
 */

export function TabBarProvider({
  children,
  initialOption = ''
}) {
  const value = React.useReducer(reducer, {
    items: [],
    currentItem: null,
    currentOption: initialOption,
    currentSubItem: '',
    history: []
  });
  const {
    theme
  } = useTheme();
  return jsx(TabBarContext.Provider, {
    value: value
  }, jsx("div", {
    css: styles({
      theme
    })
  }, children));
}